/**
 * @fileoverview Error boundary. Template sync retired; safe to edit.
 */

'use client'

import { useEffect } from 'react'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Always log full error details in error boundaries - we need complete info for debugging
    // In client components, we can't reliably check NODE_ENV, so always log full details
    // This ensures test mode always gets full error information
    console.error('[Next.js Error Boundary] Full error details:', {
      name: error.name,
      message: (error instanceof Error ? (error instanceof Error ? error.message : String(error)) : String(error)),
      stack: error.stack,
      digest: error.digest,
      // Include all error properties
      ...Object.fromEntries(
        Object.entries(error).filter(([key]) => !['name', 'message', 'stack', 'digest'].includes(key))
      )
    });
  }, [error])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background-default">
      <h1 className="text-4xl font-bold mb-4 text-foreground-default">Something went wrong!</h1>
      <p className="mb-8 text-foreground-muted">{(error instanceof Error ? (error instanceof Error ? error.message : String(error)) : String(error)) || 'An unexpected error occurred.'}</p>
      <button
        onClick={() => reset()}
        className="px-4 py-2 rounded transition-colors bg-primary text-primary-foreground hover:bg-primary-hover"
      >
        Try again
      </button>
    </div>
  )
}
